import { Box } from '@mui/material';
import React, { Suspense } from 'react';

import Header from '../../components/Header';
const LazyLineChart = React.lazy(() => import('../../components/LineChart'));

const Line = () => {
  return (
    <Box m="20px">
      <Header title="Line Chart" subtitle="Simple Line Chart" />
      <Box height="75vh">
        <Suspense fallback={<div>Loading...</div>}>
          <LazyLineChart />
        </Suspense>
      </Box>
    </Box>
  );
};

export default Line;
